import _ from 'lodash';

import {
  QueryTier1ReturnAuthorizationGroupsFilterInput,
  usePrintLabelTableLazyQuery
} from 'generated/graphql';

import { DateTime } from 'luxon';
import { listQueryUtil } from 'iron-forge-react-modules';
import * as types from './types';



export const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



export interface IBatch {
  id: string;
  requestDate: DateTime;
  referenceNumber: string;
  awaitingCartonCount: number;
  totalCount: number;
}

export interface IData {
  batches: IBatch[];
}

export function useQuery(storeId?: string) {
  return useListQuery({
    useLazyQuery: usePrintLabelTableLazyQuery,
    clientColumn2GqlSortField: {},
    defaultFilterArgs: {
      storeId
    },
    genFilter2GqlFilter: defArgs => (): QueryTier1ReturnAuthorizationGroupsFilterInput => ({
      ...defArgs,
      requiresCarton: true
    }),
    gqlResultData2GqlPageInfo: gql => gql?.tier1ReturnAuthorizationGroups.pageInfo,
    gqlResultData2TupleData: (tuple): IData => {
      const groups = _.map(tuple.data?.tier1ReturnAuthorizationGroups.nodes, (group): IBatch => ({
        id: group.id,
        referenceNumber: group.referenceNumber,
        awaitingCartonCount: group.readyForLabel.nodes.length,
        totalCount: group.totalReturnCount,
        requestDate: DateTime.fromISO(group.createdTimestamp)
      }));

      const data: IData = {
        batches: groups
      };
      return data;
    }
  });
}
